export default __webpack_public_path__ + "static/media/dog.55db4346.jpg";